module.exports = __webpack_public_path__ + "img/qq.e9f0ea55.svg";